//
//
//
//
//
//

export default {
  name: 'Columns'
}
